import axios from "axios";
import * as mutations from "../../mutation-types";

export const fetchProjectServices = (store, params = {}) => {
    return axios.get('/api/project-services', { params })
        .then(res => {
            _.each(res.data.data, item => processProjectService(store, item))
            return res
        })
}

export const processProjectService = (store, item) => {
    if (item.created_by) {
        store.dispatch('processUser', item.created_by)
        delete (item.created_by)
    }

    if (item.checklists) {
        _.each(item.checklists, item => store.dispatch('processChecklist', item))
        delete (item.checklists)
    }

    if (item.comments) {
        _.each(item.comments, item => store.dispatch('processNote', item))
        delete (item.comments)
    }

    if (item.reminders) {
        _.each(item.reminders, item => store.dispatch('processReminder', item))
        delete (item.reminders)
    }



    store.commit(mutations.ADD_OR_UPDATE_PROJECT_SERVICE, item)
}

export const processEditingProjectService = (store, item) => {
    processProjectService(store, item)
    store.commit(mutations.ADD_OR_UPDATE_EDITING_PROJECT_SERVICE, item)
}


export const reorderEditingProjectServices = (store, payload) => {
    store.commit(mutations.REORDER_EDITING_PROJECT_SERVICES, payload);
}

export const addEditingProjectService = (store, { source_type, source_id, service_id, type, work_types, arr = [] }) => {
    let service = store.getters.serviceById(service_id)

    if (arr && arr.length > 0) {
        let item = {
            id: `s` + arr.length + 1 + generateRandom9DigitNumber(),
            source_id,
            source_type,
            type,
            service_id: service.id,
            price: service.price,
            title: service.title,
            description: service.description,
            work_type_price: service.subservice_price,
            reimbursable: service.reimbursable,
            move_to_left: service,
            work_types
        }
        if (service.id) {
            store.commit(mutations.ADD_OR_UPDATE_PROJECT_SERVICE, item)
        }
    }

    if (arr && arr.length === 0) {
        let item = {
            id: `s` + arr.length + 1 + generateRandom9DigitNumber(),
            source_id,
            source_type,
            type,
            service_id: service.id,
            price: service.price,
            title: service.title,
            description: service.description,
            work_type_price: service.subservice_price,
            reimbursable: service.reimbursable,
            move_to_left: service,
            work_types
        }
        if (service.id) {
            store.commit(mutations.ADD_OR_UPDATE_PROJECT_SERVICE, item)
        }
    }

}

export const restoreProjectService = (store, { services }) => {
    let items = store.getters.serviceById(services.element.service_id)

    // let items = {
    //     id: service.element.move_to_left.id,
    //     created_at: service.element.move_to_left.created_at,
    //     deleted_at: service.element.move_to_left.deleted_at,
    //     description: service.element.move_to_left.description,
    //     include_in_retainer: service.element.move_to_left.include_in_retainer,
    //     is_active: service.element.move_to_left.is_active,
    //     is_initial: service.element.move_to_left.is_initial,
    //     is_optional: service.element.move_to_left.is_optional,
    //     last_editor_id: service.element.move_to_left.last_editor_id,
    //     price: service.element.move_to_left.price,
    //     reimbursable: service.element.move_to_left.reimbursable,
    //     subservice_price: service.element.move_to_left.subservice_price,
    //     title: service.element.move_to_left.title,
    //     todo_template: service.element.move_to_left.todo_template,
    //     updated_at: service.element.move_to_left.updated_at,
    //     work_types: service.element.move_to_left.work_types,
    // }

    // console.log(items, "restoreProjectService")

    store.commit(mutations.ADD_OR_UPDATE_EDITING_PROJECT_SERVICE, items)
    // if (services.id){
    // }

}

export const removeEditingProjectService = (store, item) => {
    store.commit(mutations.REMOVE_EDITING_PROJECT_SERVICE, item)
}

// creates project service with type 'sub-service'
// other types must be created via proposal or change order
export const createProjectService = (store, payload) => {
    return axios.post(`/api/project-services`, payload)
        .then(res => {
            if (typeof payload.id !== 'string') {
                processProjectService(store, res.data.data)
            }
            return res
        })
}

// removes ps from store
export const removeProjectService = (store, item) => {
    store.commit(mutations.REMOVE_PROJECT_SERVICE, item)
}

// removes ps, naming for historical reasons :D
export const removeProjectService2 = (store, item) => {
    return axios.delete(`/api/project-services/${item.id}`)
        .then(res => {
            removeProjectService(store, item)
            removeEditingProjectService(store, item)
            return res
        })
}

export const updateProjectService = (store, item) => {
    return axios.patch(`/api/project-services/${item.id}`, item)
        .then(res => {
            store.commit(mutations.ADD_OR_UPDATE_PROJECT_SERVICE, item)
            return res
        })
}

export const clearProjectServices = (store) => {
    _.each(_.filter(store.state.editingItems, { is_deduction: true }), item => {
        store.commit(mutations.REMOVE_PROJECT_SERVICE, item)
    })
    store.commit(mutations.SET_EDITING_PROJECT_SERVICES, [])
}

export const partialUpdateProjectService = (store, item) => {
    return axios.patch(`/api/project-services/${item.id}/partial`, item)
        .then(res => {
            store.dispatch('processProjectService', res.data.data)
            return res
        }, r => r)
}

export const clearServiceApplication = (store, item) => {
    return axios.patch(`/api/project-services/${item.id}/clearapplication`, item)
        .then(res => {
            store.dispatch('processProjectService', res.data.data)
            return res
        }, r => r)
}

export const approveProjectService = (store, item) => {
    return axios.patch(`/api/project-services/${item.id}/approve`)
        .then(res => {
            store.dispatch('processProjectService', res.data.data)
            return res
        })
}

export const billProjectService = (store, item) => {
    return axios.patch(`/api/project-services/${item.id}/bill`)
        .then(res => {
            store.dispatch('processProjectService', res.data.data)
            return res
        })
}

export const billProjectServices = (store, ids) => {
    return axios.patch(`/api/project-services/bill-all`, { ids })
        .then(res => {
            _.each(res.data.data, item => processProjectService(store, item))
            return res
        })
}

export const dropProjectServices = (store, data) => {
    return axios.post(`/api/project-services/drop`, data)
        .then(res => {
            const data = res.data.data
            const services = data.project_services || []
            services.forEach(i => store.dispatch('processProjectService', i))
            return res
        })
}

export const payProjectService = (store, item) => {
    return axios.patch(`/api/project-services/${item.id}/pay`)
        .then(res => {
            store.dispatch('processProjectService', res.data.data)
            return res
        })
}


export const scheduleLocEmail = (store, item) => {
    return axios.patch(`/api/project-services/${item.id}/schedule-loc`, item)
        .then(res => {
            processProjectService(store, res.data.data)
            return res
        })
}

export const getAccuracy = (_store, params) => {
    return axios.get(`/api/project-services/accuracy`, { params })
        .then(response => {
            return response
        });
}

export const restrictionApplied = (_store, params) => {
    return axios.post(`/api/estimated_date_restriction/restrictionApplied`, params)
        .then(response => {
            return response
        });
}

// export const getEstimatedTable = (store, id) => {
//     return axios.get(`/api/estimated_date_restriction/getEstimatedTableById/${id}`)
//         .then(response => {
//             return response
//         });
// }

const generateRandom9DigitNumber = () => {
    return Math.floor(Math.random() * 900000000) + 100000000;
}
